<template>
  <div class="rounded-2xl border border-[#1c4848]/10 bg-white p-4 shadow-sm">
    <div class="mb-3 flex items-center gap-2 text-[#1c4848]/55" data-drag-handle>
      <iconify-icon :icon="icon" class="text-base" aria-hidden="true" />
      <span class="text-[10px] font-bold uppercase tracking-widest">{{ title }}</span>
      <slot name="actions" />
    </div>
    <div class="space-y-2"><slot /></div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  icon: { type: String, required: true },
});
</script>
